import clsx from 'clsx';
import React from 'react';

import Byline from '@components/Byline';
import ArticleHeader from '@components/FeedItems/ArticleHeader';
import ArticleImage from '@components/FeedItems/ArticleImage';
import { ModalType } from '@components/MarketingModal/Content/MarketingCopy';
import type { Article } from '@interfaces/homepage';

interface RetentionP4ArticleCardProps {
  article: Article;
  className?: string;
  modalId?: string | number;
  modalType?: ModalType;
}

const RetentionP4ArticleCard = ({
  article,
  className,
  modalId,
  modalType,
}: RetentionP4ArticleCardProps) => {
  const { authors, id, isPro, newsletterSlug, picture, slug, title, posterPicture } = article;
  const utmParams = {
    utm_source: 'bc_modal',
    utm_campaign: modalType,
    utm_content: modalId ? String(modalId) : undefined,
  };

  return (
    <div
      className={clsx(
        'flex w-full flex-col gap-8 sm:flex-row sm:gap-16 md:w-[270px] md:flex-col',
        className
      )}
      data-testid="retention-p4-article-card"
    >
      <ArticleImage
        className="!h-auto w-[150px] overflow-hidden"
        id={id}
        isPro={isPro}
        newsletterSlug={newsletterSlug}
        picture={picture || ''}
        sizes="150px"
        slug={slug}
        title={title}
        utmParams={utmParams}
        posterPicture={posterPicture}
      />
      <div className="flex flex-col">
        <ArticleHeader
          className="mb-4 font-suisse-neue text-body-lg font-normal text-grayscale-charcoal"
          newsletterSlug={newsletterSlug}
          slug={slug}
          title={title}
          utmParams={utmParams}
        />
        <Byline
          authors={authors}
          authorsClassName="text-grayscale-gray"
          className="text-byline-sm text-grayscale-gray"
          newsletterSlug={newsletterSlug}
        />
      </div>
    </div>
  );
};

export default RetentionP4ArticleCard;
